import { render, staticRenderFns } from "./StoreDashboard.vue?vue&type=template&id=ef61f9a0&scoped=true"
import script from "./StoreDashboard.vue?vue&type=script&lang=js"
export * from "./StoreDashboard.vue?vue&type=script&lang=js"
import style0 from "./StoreDashboard.vue?vue&type=style&index=0&id=ef61f9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef61f9a0",
  null
  
)

export default component.exports